module.exports = __webpack_public_path__ + "90f1a139721e5d63a16038ef7e535183.svg";